import React from "react";
import "./GSTDetails.css";

function GSTDetails() {
  const gstData = [
    {
      office: "ATLAS TRAVEL HOUSE (DELHI)",
      gstin: "07FCQPS6699Q1ZW",
      address:
        "Metro Pillar No. 618, Building A5, 3rd Floor, next to Kia Showroom |, Shankar Garden, Vikaspuri, New Delhi, Delhi 110018",
    },
    {
      office: "AMOHA HOSPITALITY PVT LTD (ATLAS TRAVEL HOUSE)",
      gstin: "07ABACA5376R1Z2",
      address:
        "Third Floor , A-1B/41 , Lal Sai Marg , C 2B Janak Puri Bus Stop , Janakpuri, New Delhi , West Delhi, Delhi , 110058",
    },
    // {
    //   office: "ATLAS TRAVEL HOUSE (RAJASTHAN)",
    //   gstin: "08FCQPS6699Q1ZU",
    //   address:
    //     "2ND FLOOR, SITAPURA INDUSTRIAL AREA, S1, 24, RIICO, BEHIND SBI BANK NEAR GENPECT, SITAPURA, Jaipur, Rajasthan, 302022",
    // },
    // {
    //   office: "ATLAS TRAVEL HOUSE (MAHARASHTRA)",
    //   gstin: "27FCQPS6699Q1ZU",
    //   address:
    //     "1ST FLOOR, Office No.4, Cabin No.2, TBL Space Rayana Group - A Wing, 33/2, Balewadi, Haveli, Behind Mitcon International School, Pune, Pune, Maharashtra, 411045",
    // },
    // {
    //   office: "ATLAS TRAVEL HOUSE (UTTAR PRADESH)",
    //   gstin: "09ABACA5376R1ZY",
    //   address:
    //     "Basement, Unit No. 101, Khet-382, Adwitiya One, Chairman Market Road, Behind Yash Hero Motors, Opp. Hotel Crown Plaza, Surajpur, Greater Noida, Gautambuddha Nagar, Uttar Pradesh, 201308",
    // },
    // {
    //   office: "ATLAS TRAVEL HOUSE (HARYANA)",
    //   gstin: "06ABACA5376R1Z4",
    //   address:
    //     "944, Block C Road, Sushant Lok Phase 1, Gurugram, Gurugram, Haryana, 122001",
    // },
    // {
    //   office: "ATLAS TRAVEL HOUSE (TELANGANA)",
    //   gstin: "36ABACA5376R1Z1",
    //   address:
    //     "1st Floor, 8-2-682, #103 A&B, May Fair Garden Apartment, Road Number 12, Ohris, Banjara Hills, Hyderabad, Telangana, 500034",
    // },
    // {
    //   office: "ATLAS TRAVEL HOUSE (KARNATAKA)",
    //   gstin: "29ABACA5376R1ZW",
    //   address:
    //     "2nd Floor, 17, 7th Main Road, II Stage, Indiranagar Double Road, Bengaluru Urban, Karnataka, 560038",
    // },
    // {
    //   office: "ATLAS TRAVEL HOUSE (GOA)",
    //   gstin: "30ABACA5376R1ZD",
    //   address:
    //     "N-66, PHASE IV, VERNA INDUSTRIAL ESTATE, VERNA, SOUTH GOA, GOA, 403722",
    // },
  ];

  return (
    <section className="gst-section">
      {/* <h1 className="gst-heading">Our Presence</h1> */}
            <h2 className="gst-heading">Our Presence</h2>


      <div className="gst-container">
        {gstData.map((item, index) => (
          <div key={index} className="gst-card">
            <h2 className="gst-office">{item.office}</h2>
            <p className="gst-gstin">
              <strong>GSTIN:</strong> {item.gstin}
            </p>
            <p className="gst-address">{item.address}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default GSTDetails;
